import axios from "axios";
import store from "./store";

export const instance = axios.create({
  baseURL: "api/",
  headers: { "Content-Type": "application/json" }
});

/* Send token with each request */
instance.interceptors.request.use(
  function(config) {
    const token = store.getters["auth/token"];
    if (token) config.headers.Authorization = "Bearer " + token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

/* Check response for 401 and refresh the token */
let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(error, access_token) {
  subscribers = subscribers.filter(callback => callback(error, access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

instance.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    const {
      config,
      response: { status }
    } = error;
    const originalRequest = config;

    if (status === 401) {
      if (!isAlreadyFetchingAccessToken) {
        isAlreadyFetchingAccessToken = true;
        store
          .dispatch("auth/refreshToken")
          .then(token => {
            isAlreadyFetchingAccessToken = false;
            onAccessTokenFetched(null, token);
          })
          .catch(errorRefreshing => {
            isAlreadyFetchingAccessToken = false;
            onAccessTokenFetched(new Error("Unable to refresh access token"), null);
            throw errorRefreshing;
          });
      }

      return new Promise((resolve, reject) => {
        addSubscriber((errorRefreshing, access_token) => {
          if (errorRefreshing) {
            return reject(errorRefreshing);
          }

          if (access_token) config.headers.Authorization = "Bearer " + access_token;
          // Workaround for axios bug where the baseURL is being prepended twice
          if (originalRequest.url.startsWith(originalRequest.baseURL)) {
            originalRequest.url = originalRequest.url.slice(originalRequest.baseURL.length);
          }
          resolve(axios(originalRequest));
        });
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
